/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_History_DirectInputs */

const en_admin_funnel_history_direct = /** @type {(inputs: Admin_Funnel_History_DirectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(direct / none)`)
};

/**
* | output |
* | --- |
* | "(direct / none)" |
*
* @param {Admin_Funnel_History_DirectInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_history_direct = /** @type {((inputs?: Admin_Funnel_History_DirectInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_History_DirectInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_history_direct(inputs)
});
export { admin_funnel_history_direct as "admin.funnel.history.direct" }